module.exports = __webpack_public_path__ + "static/media/icon-close-white.b4039b58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-close-white.svg
// module id = 180
// module chunks = 0